import { DressingRuleService } from "application/dressing-rule/services";
import _ from "lodash";
import { toDate } from "core/utils";
import { TableViewStore, BaseListViewStore } from "core/stores";
import { action } from "mobx";
class DressingRuleListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const dressingRuleService = new DressingRuleService(
            rootStore.application.baasic.apiClient
        );

        super(rootStore, {
            name: "dressing-rule",
            autoInit: true,
            authorization: "administrationSection.read",
            routes: {
                create: () =>
                    rootStore.routerStore.goTo(
                        "master.app.main.dressing-rule.create"
                    ),
                edit: (id) => {
                    this.setChildNavigationTitle(
                        (i) => i.id === id,
                        (item) => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        "master.app.main.dressing-rule.edit",
                        { id: id }
                    );
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await dressingRuleService.find({
                            ...params,
                            embed: "WoundAllowedDressingCategories,WoundAllowedDressingTypes,WoundAllowedFrequencyOfCares,ProcedureCode",
                        });

                        const responseData = _.extend(response.data, {
                            item: _.map(response.data.item, (item) => {
                                return _.extend(item, {
                                    procedureCodeName: item.procedureCodeName,
                                    frequencyOfCareName:
                                        item.frequencyOfCareName,
                                    dressingTypeName: item.dressingTypeName,
                                    dressingCategoryName:
                                        item.dressingCategoryName,
                                    bordered: item.bordered,
                                    dateUpdated: toDate(item.dateUpdated),
                                    dateCreated: toDate(item.dateCreated),
                                });
                            }),
                        });
                        return responseData;
                    },
                    delete: async (item) => {
                        await dressingRuleService.delete(item);
                    },
                };
            },
        });

        this.setTableStore(
            new TableViewStore(this.queryUtility, {
                columns: [
                    {
                        key: "procedureCodeName",
                        title: "Procedure Code",
                    },
                    {
                        key: "hcpcsShortDescription",
                        title: "HCPCS Short Description",
                    },
                    {
                        key: "frequencyOfCareName",
                        title: "Frequency Of Care",
                    },
                    {
                        key: "dressingTypeName",
                        title: "Dressing Type",
                    },
                    {
                        key: "dressingCategoryName",
                        title: "Dressing Category",
                    },
                    {
                        key: "dateCreated",
                        title: "Date Created",
                    },
                    {
                        key: "dateUpdated",
                        title: "Date Updated",
                    },
                ],
                actions: {
                    onEdit: (item) => this.routes.edit(item.id),
                    onDelete: async (item) => this.deleteResource(item),
                },
            })
        );
    }

    @action.bound
    async deleteResource(item) {
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm("Delete dressing rule?", async () => {
            try {
                await this.actions.delete(item);
                notificationStore.success(
                    "Successfully deleted dressing rule."
                );
                await this.queryUtility.fetch();
            } catch (err) {
                notificationStore.error(
                    "Error occured while deleting the dressing rule",
                    err
                );
            }
        });
    }
}

export default DressingRuleListViewStore;
